angular.module('app.controllers').controller('FavsCtrl', ['$scope', '$rootScope', 'APIFavorites', 'APIFavoritesTable', 'Table', '$filter', '$location', 'detectUtils', 'deviceDetector', 'UI'].append(function(self, root, APIFavorites, APIFavoritesTable, Table, $filter, $location, detectUtils, deviceDetector, UI) {
  self.urlcode = self.get('code') || null;
  if ((self.urlcode != null) && String(self.urlcode).length !== 7) {
    return $location.path("/favoriten");
  }
  self.sharecode = (btoa(root.shortcode || 'test')).substr(0, 7);
  self.ex = Table({
    name: 'jb.fav.ex',
    type: "partial",
    resource: APIFavoritesTable,
    cookies: false,
    params: {
      entrycode: 'ex',
      shortcode: root.shortcode || 'test',
      urlcode: self.urlcode,
      fullentry: true,
      limit: 24
    }
  });
  self.jo = Table({
    name: 'jb.fav.jo',
    type: "partial",
    resource: APIFavoritesTable,
    cookies: false,
    params: {
      entrycode: 'jo',
      shortcode: root.shortcode || 'test',
      urlcode: self.urlcode,
      fullentry: true,
      limit: 12
    }
  });
  self.ph = Table({
    name: 'jb.fav.ph',
    type: "partial",
    resource: APIFavoritesTable,
    cookies: false,
    params: {
      entrycode: 'ph',
      shortcode: root.shortcode || 'test',
      urlcode: self.urlcode,
      fullentry: true,
      limit: 10
    }
  });
  self.tt = Table({
    name: 'jb.fav.tt',
    type: "partial",
    resource: APIFavoritesTable,
    cookies: false,
    params: {
      entrycode: 'tt',
      shortcode: root.shortcode || 'test',
      urlcode: self.urlcode,
      fullentry: true,
      limit: 12
    }
  });
  self.page = {
    ex: 1,
    jo: 1,
    ph: 1,
    tt: 1
  };
  self.moreLoad = {
    ex: false,
    jo: false,
    ph: false,
    tt: false
  };
  self.loadMore = function(slug) {
    var params;
    if (self.page[slug] >= self[slug].data.pages) {
      return;
    }
    self.page[slug]++;
    params = angular.copy(self[slug].params);
    params.page = self.page[slug];
    self.moreLoad[slug] = true;
    return APIFavorites.query(params, function(data) {
      self.more = data;
      self[slug].data.display = self[slug].data.display.concat(self.more);
      return self.moreLoad[slug] = false;
    });
  };
  APIFavorites.query({
    entrycode: 'do',
    shortcode: root.shortcode || 'test',
    urlcode: self.urlcode,
    fullentry: true
  }, function(data) {
    return self.do = data;
  });
  root.$on('forceFavs', function(event, slug) {
    if (slug === 'do' || self.at('share')) {
      return;
    }
    return self[slug].reload();
  });
  self.isFavsFilter = function(item, index, array) {
    return self.isFavs('do', item.exhibitor_id, item.entry_id);
  };
  self.isMobile = function() {
    return detectUtils.isMobile() && deviceDetector.device !== "mac";
  };
  self.copyToClipboard = function(link) {
    var el;
    el = document.createElement('textarea');
    el.value = link;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    return UI.notify(true, 'Erfolgreich in der Zwischenablage gespeichert');
  };
  return self.printPage = function() {
    window.print();
    return false;
  };
}));
